import axios from 'axios';
import { Message, MessageBox, Loading } from 'element-ui';
import { getToken } from '@/utils/auth';
import systemConfig from '@/config';
// eslint-disable-next-line import/no-cycle
import store from '@/store';

const errorWhiteList = [];

function isShowLoadingAndError(config) {
  return (
    config.headers.unmask ||
        errorWhiteList.some(item => config.url && config.url.indexOf(item) > -1)
  );
}
// 创建axios实例
const service = axios.create({
  baseURL: systemConfig.baseURL || 'function', // api 的 base_url
  timeout: 60000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (!isShowLoadingAndError(config)) {
      store.state.app.ajaxCount += 1;
    }
    if (!config.headers.token) {
      config.headers.token = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  },
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    if (!isShowLoadingAndError(response.config)) {
      store.state.app.ajaxCount -= 1;
    }
    if (response.config.responseType === 'arraybuffer') {
      return response.data;
    }
    /**
         * error_no为非0是抛错
         */
    const res = response.data;
    if ((res.err_no && res.err_no !== 0) || (res.error_no && res.error_no !== 0)) {
      if ((res.err_no && res.err_no !== 200) || (res.error_no && res.error_no !== 200)) {
        console.log('err');
        if (!isShowLoadingAndError(response.config)) {
          Message({
            message: res.error_msg || res.err_msg,
            type: 'error',
            duration: 5 * 1000,
          });
        }
        return Promise.reject(res);
      }
    }
    return response.data;
  },
  (error) => {
    console.log(error);
    const { response } = error;
    if (!isShowLoadingAndError(response.config)) {
      store.state.app.ajaxCount -= 1;
    }
    console.log(`err${error}`); // for debug
    if (response && !isShowLoadingAndError(response.config)) {
      Message({
        message: (response.data && response.data.error_msg) || error.message,
        type: 'error',
        duration: 5 * 1000,
      });
    }

    return Promise.reject(error);
  },
);

export default service;
